import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  startAfter,
  updateDoc,
  where,
} from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { developerApplicationStatus } from '../../constants/DeveloperApplication';
import { extractSubdomainFromAddressBar } from '../../utils';
import type { IDeveloperApplicationService, IDeveloperApplicationState } from '../DeveloperApplicationService';
import { firestoreDB } from './config';

let latestDoc: any = null;

export default class FireServiceAdapter implements IDeveloperApplicationService {
  async saveDeveloperApplication(params: any): Promise<{ id: string }> {
    const ts = serverTimestamp();
    const developerApplication = {
      ...params,
      id: uuidv4(),
      createdAt: ts,
      subdomain: extractSubdomainFromAddressBar(),
      status: developerApplicationStatus.SUBMITTED,
      timeline: [
        {
          id: uuidv4(),
          content: 'Application submitted',
          date: new Date().toDateString(),
          eventType: 'submitted',
          target: '',
        },
      ],
    };
    const developerApplicationColRef = collection(firestoreDB, 'developer-application');
    await addDoc(developerApplicationColRef, developerApplication);

    return {
      id: developerApplication.id,
    };
  }

  async changeDeveloperApplicationStatus(
    status: string,
    docId: string,
    event?: {
      content: string;
      date: string;
      eventType: string;
      target: string;
    }[]
  ) {
    const _developerApplication = await this.updateDocumnet('developer-application', docId, {
      status,
      timeline: event,
    });
  }

  async fetchDeveloperApplication(docId: string): Promise<IDeveloperApplicationState> {
    const developerApplication: IDeveloperApplicationState = await this.fetchDocumentByDocId('developer-application', docId);
    return developerApplication;
  }

  async listDeveloperApplications(account: string): Promise<IDeveloperApplicationState[]> {
    const developerApplications = await this.collectionAll('developer-application', account);
    return developerApplications;
  }

  async deleteOpportunity(docId: string): Promise<void> {
    const docRef = doc(firestoreDB, 'opportunities', docId);
    await deleteDoc(docRef);
    // await this.documentDeleteRequest("opportunities", id);
  }

  // async documentDeleteRequest(collection: string, id: string) {
  //   const ref = await fireStoreDB.collection(collection).where("ID", "==", id);
  //   ref.get().then(function (querySnapshot) {
  //     querySnapshot.forEach(function (doc) {
  //       doc.ref.delete();
  //     });
  //   });
  // }

  async documentDeleteRequestByOpportunityID(col: string, docId: string) {
    const docRef = doc(firestoreDB, col, docId);
    await deleteDoc(docRef);
    // const ref = await fireStoreDB
    //   .collection(collection)
    //   .where("Opportunity_ID", "==", id);
    // ref.get().then(function (querySnapshot) {
    //   querySnapshot.forEach(function (doc) {
    //     doc.ref.delete();
    //   });
    // });
  }

  // async collectionPostRequest(collection: string, items: {}) {
  //   await fireStoreDB.collection(collection).add(items);
  // }

  async fetchDocumentByDocId(col: string, docId: string): Promise<any> {
    const docRef = doc(firestoreDB, col, docId);
    const ref = await getDoc(docRef);
    return { ...ref.data(), docId: ref.id };
  }

  async updateDocumnet(col: string, docId: string, payload: any) {
    const docRef = doc(firestoreDB, col, docId);
    const ref = await updateDoc(docRef, payload);
    return ref;
  }

  async collectionAll(col: string, subdomain: string) {
    const colRef = collection(firestoreDB, col);
    const q = query(colRef, where('subdomain', '==', subdomain), orderBy('createdAt', 'desc'), limit(10));
    const ref = await getDocs(q);
    const data: any = [];
    ref.docs.map((doc) =>
      data.push({
        ...doc.data(),
        docId: doc.id,
      })
    );
    return data;
  }

  async postComment(params: any) {
    const ts = serverTimestamp();
    const comment = {
      ...params,
      id: uuidv4(),
      createdAt: ts,
    };
    const developerApplicationCommentColRef = collection(firestoreDB, 'developer-application-comments');
    await addDoc(developerApplicationCommentColRef, comment);
  }

  async fetchDeveloperApplicationComments(applicationDocId: string | undefined) {
    const colRef = collection(firestoreDB, 'developer-application-comments');
    const q = query(colRef, where('applicationDocId', '==', applicationDocId), orderBy('createdAt', 'asc'));
    const ref = await getDocs(q);
    const data: any = [];
    ref.docs.forEach((doc) => {
      data.push({
        ...doc.data(),
        docId: doc.id,
      });
    });
    return data;
  }

  async fetchMoreDeveloperApplicationComments(applicationDocId: string | undefined, _lastDoc: any) {
    const colRef = collection(firestoreDB, 'developer-application-comments');
    const q = query(
      colRef,
      where('applicationDocId', '==', applicationDocId),
      orderBy('createdAt', 'asc'),
      startAfter(latestDoc || 0),
      limit(5)
    );

    const ref = await getDocs(q);
    latestDoc = ref.docs[ref.docs.length - 1];
    const data: any = [];

    ref.docs.forEach((doc) => {
      data.push({
        ...doc.data(),
        docId: doc.id,
      });
    });
    return data;
  }
}
